import { useId } from "react";
import {
  CLEAR_NIGHT_STARS,
  GardenGround,
  SkySvgShell,
  VIEW_HEIGHT,
  VIEW_WIDTH,
} from "@/app/components/weather/backgrounds/shared";

/**
 * ClearNightSky — deep indigo night sky with stars and a crescent moon.
 * Full-viewport illustration; garden silhouettes anchor to the bottom edge.
 */
export function ClearNightSky() {
  const uid = useId().replace(/:/g, "");
  const sky = `${uid}-sky`;
  const moonGlow = `${uid}-moon`;
  const haze = `${uid}-haze`;

  return (
    <SkySvgShell>
      <defs>
        <linearGradient id={sky} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#040818" />
          <stop offset="35%" stopColor="#0A1430" />
          <stop offset="70%" stopColor="#121E40" />
          <stop offset="100%" stopColor="#1A2850" />
        </linearGradient>
        <radialGradient id={moonGlow} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#E8E0FF" stopOpacity="0.4" />
          <stop offset="50%" stopColor="#C8B8EE" stopOpacity="0.12" />
          <stop offset="100%" stopColor="#A898DD" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={haze} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#121E40" stopOpacity="0" />
          <stop offset="100%" stopColor="#0A1220" stopOpacity="0.9" />
        </linearGradient>
      </defs>

      <rect width={VIEW_WIDTH} height={VIEW_HEIGHT} fill={`url(#${sky})`} />

      {CLEAR_NIGHT_STARS.map(([x, y, r, o], i) => (
        <circle key={i} cx={x} cy={y} r={r} fill="#E8E4FF" opacity={o} />
      ))}

      <ellipse cx="290" cy="78" rx="90" ry="85" fill={`url(#${moonGlow})`} />
      <path
        d="M 290 38 A 40 40 0 1 0 290 118 A 32 32 0 1 1 290 38 Z"
        fill="#E0D8F8"
        opacity="0.92"
      />

      <rect x="0" y="200" width={VIEW_WIDTH} height={VIEW_HEIGHT - 200} fill={`url(#${haze})`} />

      <GardenGround />
    </SkySvgShell>
  );
}
